import { render, staticRenderFns } from "./VaccinationType.vue?vue&type=template&id=5bfb1839&scoped=true&"
import script from "./VaccinationType.vue?vue&type=script&lang=js&"
export * from "./VaccinationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfb1839",
  null
  
)

export default component.exports